// Кто играет: me (профиль, роль, способы входа) или null — гость ещё не заведён / не вошёл.
import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';
import { api, session, ApiError } from '../platform/api.ts';
import { inTelegram } from '../platform/telegram.ts';

export type Method = { provider: 'email' | 'vk' | 'telegram'; subject: string; label: string };
export type Me = {
  profile: { id: string; nick: string | null; city: string | null; is_guest: boolean; is_veteran: boolean; level: number; has_email: boolean; ref_code: string };
  role: 'owner' | 'content' | 'support' | null;
  methods: Method[];
  available: { telegram: boolean; email: boolean; vk: boolean; bot: string };
};

type Ctx = { me: Me | null; ready: boolean; reload: () => Promise<void>; logout: () => Promise<void> };
const C = createContext<Ctx>({ me: null, ready: false, reload: async () => {}, logout: async () => {} });
export const useMe = () => useContext(C);

export function MeProvider({ children }: { children: ReactNode }) {
  const [me, setMe] = useState<Me | null>(null);
  const [ready, setReady] = useState(false);
  const reload = useCallback(async () => {
    if (!inTelegram() && !session.get()) { setMe(null); setReady(true); return; }
    try { setMe(await api<Me>('me')); }
    catch (e) {
      if (e instanceof ApiError && e.status === 401 && !inTelegram()) session.clear();
      setMe(null);
    }
    setReady(true);
  }, []);
  const logout = useCallback(async () => {
    await api('auth_logout').catch(() => {});
    session.clear();
    setMe(null);
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return <C.Provider value={{ me, ready, reload, logout }}>{children}</C.Provider>;
}
